import { Outlet } from 'react-router-dom'

import { SpaceControlRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/space_control/lib/CollectionsBootstrap'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data } = useQuery(SpaceControlRootPageDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const isAvailable = data?.companies.moduleAvailabilitiesConnection.nodes[0]?.available ?? false

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => isAvailable}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
